// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__1Wv2u","validationTips":"StatementDescriptor_validationTips__2a3uJ"};